// extracted by mini-css-extract-plugin
export default {"price_tab":"pricing_price_tab__sjIoH","price_top":"pricing_price_top__TnK+C","price_list":"pricing_price_list__xtpMH","btn":"pricing_btn__oRq8o"};